import { ActionTree } from "vuex";
import { ClassTeachingState } from "./state";

const actions: ActionTree<ClassTeachingState, any> = {
  //
};

export default actions;
